import { SidebarInset } from '@goaltree/ui/components/sidebar'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { AppSidebar } from '@/components/app-sidebar'
import { MobileScreenHeader } from '@/components/mobile-screen-header'
import { PersistentSidebarProvider as SidebarProvider } from '@/components/persistent-sidebar-provider'
import { SiteHeader } from '@/components/site-header'
import { WeeklyReviewWizard } from '@/components/weekly-review-wizard'

export const Route = createFileRoute('/_authenticated/review')({
  head: () => ({
    meta: [{ title: 'Weekly Review — Goaltree' }, { name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="h-svh overflow-hidden bg-background">
        <MobileScreenHeader title={t('review.title')} showInbox={false} />
        <SiteHeader className="hidden lg:flex" />
        <div className="flex-1 overflow-y-auto">
          <div className="bg-background px-4 h-full">
            <div className="mx-auto max-w-(--page-col) h-full">
              <WeeklyReviewWizard onClose={() => navigate({ to: '/today' })} />
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
